import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import styled from "styled-components";
import { Form } from "react-bootstrap";

const StyledInput = styled(Form.Control)`
    padding-left: 1.9rem;
    background-image: url("/images/search.png");
    background-repeat: no-repeat;
    background-position: left calc(0.375em + 0.1875rem) center;
    background-size: calc(.9rem + 0.075rem) calc(.9rem + 0.075rem);
`;

export type FormInputWithSearchIconProps = DetailedHTMLProps<HTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const FormInputWithSearchIcon = React.forwardRef(({ ...props } : Readonly<FormInputWithSearchIconProps>, ref) : JSX.Element => {
    return <StyledInput ref={ref} {...props} />
});